import React from "react";
import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export default function AuthLayout({ eyebrow, title, children, footer }) {
  return (
    <div className="ambient relative flex min-h-screen items-center justify-center overflow-hidden bg-[#0a0a0b] px-4 py-12">
      <div className="grid-bg pointer-events-none absolute inset-0 opacity-40" />
      <div className="relative z-10 w-full max-w-sm">
        <Link to="/" className="mb-10 flex items-center justify-center gap-2.5" data-testid="auth-logo">
          <span className="grid h-9 w-9 place-items-center rounded-md bg-gradient-to-br from-[#f3f4f6] to-[#aeb3b9] text-black"><Zap size={17} /></span>
          <span className="font-head text-base font-extrabold tracking-tight text-silver">SANJAY LIMITLESS</span>
        </Link>
        <div className="surface rounded-2xl p-7">
          <div className="mb-6">
            <div className="font-mono text-[11px] uppercase tracking-widest text-neutral-500">{eyebrow}</div>
            <h1 className="mt-2 font-head text-2xl font-bold uppercase tracking-tight text-white">{title}</h1>
          </div>
          {children}
        </div>
        {footer && <div className="mt-5 text-center font-mono text-[11px] uppercase tracking-widest text-neutral-500">{footer}</div>}
        <p className="mt-6 text-center text-[11px] text-neutral-700">Trading involves risk. Past performance does not guarantee future results.</p>
      </div>
    </div>
  );
}

export function Field({ label, type = "text", value, onChange, placeholder, testid, hint, ...rest }) {
  return (
    <label className="mb-4 block">
      <span className="mb-2 block font-mono text-[10px] uppercase tracking-widest text-neutral-500">{label}</span>
      <input
        type={type} value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder}
        data-testid={testid}
        className="w-full rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3 font-mono text-sm text-white placeholder:text-neutral-600 outline-none transition-colors focus:border-[#d4d8dc]/60"
        {...rest}
      />
      {hint && <span className="mt-1.5 block text-[11px] text-neutral-600">{hint}</span>}
    </label>
  );
}
